import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

const I18N = 'app.patrol.discord.cockpit';

@Component({
  selector: 'app-patrol-discord-guild-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './patrol-discord-guild-switcher.component.html',
  styleUrl: './patrol-discord-guild-switcher.component.scss',
})
export class PatrolDiscordGuildSwitcherComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly i18n = I18N;

  readonly guilds = this.#cockpit.guilds;
  readonly selectedRegistryId = this.#cockpit.selectedRegistryId;
  readonly isLoading = this.#cockpit.isLoadingGuilds;
  readonly isAdding = this.#cockpit.isAddingGuild;
  readonly errorKey = this.#cockpit.guildsError;

  readonly showCreateForm = signal(false);
  readonly newServerName = signal('');

  selectGuild(registryId: string): void {
    this.#cockpit.selectGuild(registryId);
  }

  toggleCreateForm(): void {
    this.showCreateForm.update((open) => !open);
    if (!this.showCreateForm()) {
      this.newServerName.set('');
    }
  }

  async submitCreateForm(): Promise<void> {
    const displayName = this.newServerName().trim();
    if (!displayName) {
      return;
    }

    const created = await this.#cockpit.addGuild(displayName);
    if (created) {
      this.newServerName.set('');
      this.showCreateForm.set(false);
    }
  }
}
